export const inArray = (state) => Object.values(state.list);
export const byId = (state) => (id) => state.list[id];

export const inTypeArray = (state) => Object.values(state.types);
export const byTypeId = (state) => (id) => state.types[id];
